import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<div class=\"c-about\">\n  {{yield}}\n</div>",{ moduleName: "mewe/pods/components/cms/routable/about/template.hbs" })